import { UserRole } from "@next-platform/packages-ts-types";
var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTHLY"] = "monthly";
    BillingCycle["QUARTERLY"] = "quarterly";
    BillingCycle["ANNUAL"] = "annual";
})(BillingCycle || (BillingCycle = {}));
const UserRoles = {
    MINIMAL: UserRole.PAID_MINIMAL,
    BASIC: UserRole.PAID_BASIC,
    PREMIUM: UserRole.PAID_PREMIUM,
    FREE: UserRole.FREE,
    EMPLOYEE: UserRole.EMPLOYEE,
};
var SubscriptionTiers;
(function (SubscriptionTiers) {
    SubscriptionTiers["MINIMAL"] = "Get a Taste";
    SubscriptionTiers["BASIC"] = "True Supporter";
    SubscriptionTiers["PREMIUM"] = "I'm All In";
    SubscriptionTiers["FREE"] = "Free";
    SubscriptionTiers["ANONYMOUS"] = "Anonymous User";
})(SubscriptionTiers || (SubscriptionTiers = {}));
var PermissionsBanTypes;
(function (PermissionsBanTypes) {
    PermissionsBanTypes["RESTRICTION_TEMPORARY"] = "restriction_full_time";
    PermissionsBanTypes["LIMITED_ACCESS"] = "restriction_limited";
    PermissionsBanTypes["RESTRICTION_COMPLETE"] = "restriction_full";
    PermissionsBanTypes["NONE"] = "n/a";
})(PermissionsBanTypes || (PermissionsBanTypes = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELLED"] = "cancelled";
    SubscriptionStatus["EXPIRED"] = "expired";
    SubscriptionStatus["GRACE"] = "grace";
    SubscriptionStatus["PAUSED"] = "paused";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var FeatureFlags;
(function (FeatureFlags) {
    FeatureFlags["TTS"] = "tts_enabled";
    FeatureFlags["V2"] = "gui_v2_enabled";
})(FeatureFlags || (FeatureFlags = {}));
var FeaturePermissions;
(function (FeaturePermissions) {
    FeaturePermissions["TTS"] = "tts";
    FeaturePermissions["TTS_CUSTOM_VOICES"] = "tts_custom_voices";
    FeaturePermissions["GROUP_AUTO_RESPONSE"] = "group_auto_response";
    FeaturePermissions["DEBUG_CHAT"] = "debug_chat";
})(FeaturePermissions || (FeaturePermissions = {}));
var UserFlow;
(function (UserFlow) {
    UserFlow["SUBSCRIPTION"] = "Subscription";
    UserFlow["UPDATE_PROFILE"] = "UpdateProfile";
})(UserFlow || (UserFlow = {}));
export { BillingCycle, FeatureFlags, FeaturePermissions, PermissionsBanTypes, SubscriptionStatus, SubscriptionTiers, UserFlow, UserRoles };
